import { capitalize } from "lodash-es";

import { Pill } from "src/design-system/Pill";
import { JobStatus } from "src/jobs/types";

export const JobStatusPill = ({ status }: { status: JobStatus }) => (
  <Pill variant={status === "active" ? "green" : "gray"}>
    <Pill.Text>{capitalize(status)}</Pill.Text>
  </Pill>
);
